import { left } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import { UpdateDashboardPinClient } from 'use-case/dashboard/update/updateDashboardClient';
import { callbackParseDashboardResponse } from 'adapter/out/client/dashboard/callbackParseDashboardResponse';
import { UpdateDashboardPinCriteria } from 'use-case/dashboard/update/updateDashboardCriteria/updateDashboardPinCritera';

export default (httpClient: httpClientFunction, baseUrl: string): UpdateDashboardPinClient => (criteria: UpdateDashboardPinCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.id}/pin`, {
        method: 'POST',
        body: JSON.stringify(asDashboardJson(criteria)),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) => callbackParseDashboardResponse(response))
        .catch(() => left({ error: new Error(), status: 503 }));

export const asDashboardJson = (criteria: UpdateDashboardPinCriteria): DashboardUpdatePinJsonRequest => ({
    pinned: criteria.pinned,
});

export type DashboardUpdatePinJsonRequest = {
    pinned: boolean;
};
